import notifier from '@/mixins/notifier'

export default {
	mixins: [notifier],

	data() {
		return {}
	},

	methods: {
		async editTask(orderId, task) {
			if (task === null || task === undefined) return;

			const fullInfo = (
				await this.$http.get(
					`/${this.$store.state.auth.role}/task/view/${task.id}`
				)
			).data.data;

			this.task = {
				id: task.id,
				order: { id: orderId },
				date_time: task.date_time,
				description: task.description,
				is_by_admin: fullInfo.is_by_admin
			};

			this.popupActiv = true;
		},

		async createTask(list = []) {
			this.activePrompt = true
			if(await this.$validator.validateAll() !== true) { return; }

			try {
				this.activePrompt = false;
				this.activePromptCounter++;

				const newTask = await this.dbCreateTask(this.date, this.about, this.idOrder);

				this.about = "";
				this.date = new Date();
				this.popupActiv = false;

				if (list && list.length) {
					list.forEach((el) => {
						if (el.id === this.idOrder) {
							el.task = newTask
						}
					})

					this.notifySuccess(this.$t("addedSuccessfully"));
					return
				}
				const ticket = this.findTicketAnywhere(this.idOrder);

				if(!!ticket) {
					ticket.task = newTask;
				}

				this.sortTab(ticket.status);

				this.notifySuccess(this.$t("addedSuccessfully"));

			} catch (e) {
				this.notifyError(e.message)
			}
		},

		findTicketAnywhere(id) {
			let ticket;
			for(let tab of this.tabs) {
				ticket = this.findTicket(tab.key, id);

				if(ticket !== undefined) break;
			}

			return ticket;
		},

		findTicket(tab, id) {
			const res = this.orders[tab].filter(
				(order) => order.id === id
			)[0];
			return res;
		},
	}
}
